var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7773",
    "data-name": "Group 7773",
    transform: "translate(-672 -475.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3164",
    "data-name": "Ellipse 3164",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(672 475.5)",
    fill: "#def3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M23.369,9.487A9.109,9.109,0,0,0,5.984,11.947,5.2,5.2,0,0,0,7.207,22.213a1.3,1.3,0,1,0,0-2.6,2.6,2.6,0,0,1,0-5.2,1.3,1.3,0,0,0,1.3-1.3A6.506,6.506,0,0,1,21.17,11.01a1.3,1.3,0,0,0,1.015.872,3.9,3.9,0,0,1,.312,7.6A1.3,1.3,0,1,0,23.147,22a6.506,6.506,0,0,0,.221-12.518Zm-7.43,2.694a1.345,1.345,0,0,0-1.848,0l-3.9,3.9a1.307,1.307,0,0,0,1.848,1.848l1.679-1.692v7.274a1.3,1.3,0,0,0,2.6,0V16.241l1.679,1.692a1.307,1.307,0,1,0,1.848-1.848Z",
    transform: "translate(687.009 491.488)",
    fill: "#1487ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/Upload_Image.28b2b09b2c6f4d203683ee63e241659c.svg";
export { ForwardRef as ReactComponent };